import { render, staticRenderFns } from "./integration-deliveries-data-table.vue?vue&type=template&id=37d35c33&scoped=true"
import script from "./integration-deliveries-data-table.vue?vue&type=script&lang=js"
export * from "./integration-deliveries-data-table.vue?vue&type=script&lang=js"
import style0 from "./integration-deliveries-data-table.vue?vue&type=style&index=0&id=37d35c33&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d35c33",
  null
  
)

export default component.exports